import axios from 'axios';

/**
 * Authenticate the user and get it token to perform authenticated requests to the backend.
 * 
 * @param {String} email
 * @param {String} password
 * 
 * @returns {String} the token obtained from the authentication.
 */
async function authenticate(email, password) {
  return axios.post(process.env.VUE_APP_AUTH_API_URL, { email, password }).then(({ data }) => data.token)
}

export default {
  authenticate
}
